<iframe [src]="scriptUrl | safeUrl" class="custom-iframe" [ngClass]="{'visible': startAnimation}" (load)="onLoad()"  [id]="id"></iframe>